import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAIF8rOdpAQl_2803Ca2DLMBzEovLdu3Kg",
  authDomain: "trebel-modes.firebaseapp.com",
  projectId: "trebel-modes",
  storageBucket: "trebel-modes.appspot.com",
  messagingSenderId: "247663673185",
  appId: "1:247663673185:web:36fafab7473ce89448cf20",
  measurementId: "G-YJ7CB55C6H"
};

firebase.initializeApp(config);
const analytics = firebase.analytics();

export { analytics };
